import { useEffect, useState } from 'react';

const navs = [
  { label: '本周热榜', href: '#weekly' },
  { label: '年度大瓜', href: '#annual' },
  { label: '名场面', href: '#moments' },
  { label: '深扒专题', href: '#features' },
  { label: '常见问题', href: '#faq' },
  { label: '关于本站', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="px-4 md:px-6">
        <div className="mx-auto flex h-16 max-w-[1240px] items-center justify-between gap-4">
          {/* 品牌 */}
          <a
            href="#top"
            aria-label="瓜友观察站首页"
            className="flex items-center gap-2.5 whitespace-nowrap"
          >
            <span
              className={`flex h-9 w-9 items-center justify-center rounded-lg text-lg text-background-50 ${
                solid ? 'bg-primary-500' : 'bg-primary-500/90'
              }`}
            >
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
            </span>
            <span
              className={`font-heading text-lg font-bold tracking-tight ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              瓜友观察站
            </span>
          </a>

          {/* 桌面导航 */}
          <div className="hidden items-center gap-1 lg:flex">
            {navs.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className={`rounded-full px-3.5 py-2 text-sm whitespace-nowrap transition-colors ${
                  solid
                    ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                    : 'text-background-100 hover:bg-background-50/10 hover:text-white'
                }`}
              >
                {n.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#subscribe"
              className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex ${
                solid
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-primary-700 hover:bg-white'
              }`}
            >
              订阅追更
              <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-md text-xl lg:hidden ${
                solid ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              <i className={open ? 'ri-close-line' : 'ri-menu-3-line'} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="mx-auto flex max-w-[1240px] flex-col">
            {navs.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm text-foreground-800 last:border-none"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex w-full items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              订阅追更
              <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}